<template>
  <div class="debug">
    <h2>login to {{ {concertId} }}</h2>
    <div>
      <div class="buttonMini debugButton" @click="login">login</div>
      <div class="buttonMini debugButton" @click="removeToken">remove token</div>
      <div class="buttonMini debugButton" @click="removeAllToken">remove Alltoken</div>
    </div>
    <div class="debugUserId">user id: {{ userId }}</div>
  </div>
</template>

<script>
import API from "../../api/API";

import Storage from "../../api/Storage";
import * as commonStoreTypes from "../../store/modules/common/types";
export default {
  name: "LoginTest",
  props: ["concertId"],
  computed: {
    userId() {
      return this.$store.state.common.userId;
    }
  },
  methods: {
    async login() {
      const result = await API.login(this.concertId);
      console.log("result", result);
      if (result) this.token = result;
    },
    removeToken() {
      this.$store.dispatch(
        commonStoreTypes.namespace + commonStoreTypes.SET_USER_ID,
        {
          concertId: this.$store.state.concert.concertId
        }
      );
    },
    removeAllToken() {
      this.$store.dispatch(
        commonStoreTypes.namespace + commonStoreTypes.SET_USER_ID,
        {
          concertId: this.$store.state.concert.concertId
        }
      );
      Storage.removeAll();
    }
  }
};
</script>

<style scoped lang="sass">
  @import "../../sass/common"
  .debugUserId
    width: 100%
    //text-overflow: clip
    //white-space: pre-wrap
    overflow: hidden
</style>
